export default function Project(){
    return (
        <div className="project">
            <div class="p-10 border-b-4">
          <p class="text-sky-700 text-4xl ">PROJECT</p>
          <div class="pl-10">
                  <span class="text-2xl">AduitCode</span> 
                  <ul className="pl-10">
                    <li>• Proposed a project aimed at streamlining the teaching-learning process for both lecturers and students.</li>
                    <li>• Developed a parser system to recognize coding language keywords and reserved words,
            enabling proper code formatting using python.
            </li>          
                    <li>• Designed and implemented a Visual Studio Code-like theme specifically for Python files.
                    </li>          
                    <li>• Created an efficient search system for navigating folders within the editor.
                    </li>          
                  </ul>
            <span class="text-2xl">Chat App</span>
            <ul className="pl-10">
              <li>• Developed a web application enabling secure real-time text communication between users.</li>
              <li>• Integrated an admin panel to oversee the app's overall administration and user management.
              </li>
              <li>• Gained hands-on experience with sockets and real-time applications using Node.js
              </li>
              <li>• Ensured the website is fully responsive across tablets and mobile devices.
              </li>
            </ul>
            <span class="text-2xl">Travel blog website</span>
            <ul className="pl-10">
              <li>• Designed and built a website to showcase advanced CSS animation skills and foundational
            DBMS integration, enhancing the functionality of a static site.
            </li>
            <li>• Embedded 3D models to provide an immersive experience, illustrating locations as I experienced
            them during my journey.
            </li>
            <li>• Implemented dynamic content management to allow easy updates and scalability of the site.
            </li>
            <li>• Ensured the website is fully responsive across tablets and mobile devices.
            </li>
            </ul>
          </div>
        </div>
        
        </div>
    );
}